import Icon from '../components/Icon.vue'

Icon.register({
  neuter: {
    width: 288,
    height: 512,
    paths: [
      {
        d: 'M288 176c0 68.5-47.9 125.9-112 140.4v151.6c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-151.6c-64.1-14.5-112-71.9-112-140.4 0-79.5 64.5-144 144-144s144 64.5 144 144zM144 256c44.1 0 80-35.9 80-80s-35.9-80-80-80-80 35.9-80 80 35.9 80 80 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/neuter.js
// module id = 1591
// module chunks = 0